import { createFileRoute, Navigate } from "@tanstack/react-router";

// Safety net for old bookmarks or external links pointing to /signup.
// Signup goes through /signin (OTP flow, shouldCreateUser: true).
export const Route = createFileRoute("/signup/")({
    component: () => <Navigate to="/signin" replace />,
});
